<template>
  <div class="home">
    <div class="back" @click="sendDataToUnity('Close')">
      <div>
        <img src="../../assets/img/back.png" alt="" />
        <p>{{ language === "zh" ? "小游戏" : "More" }}</p>
      </div>
    </div>
    <div class="explain">
      <p>【B】{{ language === "zh" ? "返回" : "Back" }}</p>
      <p>【A】{{ language === "zh" ? "确认" : "Confirm" }}</p>
    </div>
    <!-- <p class="test">{{ language }}{{ token }}</p> -->
    <!-- <p class="test">222{{ back }}</p> -->
    <div class="box">
      <div class="infinite-list-wrapper" style="overflow: auto; height: 100%">
        <ul
          class="list"
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
          :infinite-scroll-distance="50"
        >
          <li
            v-for="(item, index) in gameList"
            :key="item.id"
            :class="['list-item', { selected: index === selectedIndex }]"
            @click="goGame(item)"
            ref="items"
          >
            <div class="arrow" v-if="index === selectedIndex">
              <img src="../../assets/img/arrow.png" alt="" />
            </div>
            <div class="item-img">
              <div>
                <img :src="item.webGameCover" alt="" />
              </div>
              <!--  -->
            </div>
            <p>
              <span></span>
              {{ item[language] }}
              <span></span>
            </p>
          </li>
        </ul>
        <p v-if="loading">
          {{ language === "zh" ? "加载中..." : "Loading..." }}
        </p>
        <p v-if="noMore">
          {{ language === "zh" ? "没有更多了..." : "No more..." }}
        </p>
      </div>
    </div>
    <!-- 提示没收到数据弹框 -->
    <el-dialog :visible.sync="dialogVisible" width="50%" class="message-dialog">
      <div class="message-close" @click="dialogVisible = false">
        <img src="../../assets/img/message-close.png" alt="" />
      </div>
      <div class="message-box">
        <img src="../../assets/img/message-error.png" alt="" />
        <p>长时间未收到数据，请返回App重新连接蓝牙</p>
        <div class="message-btn">
          <p @click="dialogVisible = false">
            <img src="../../assets/img/message-cancel.png" alt="" />
            <span>取消</span>
          </p>
          <p @click="enterEsc">
            <img src="../../assets/img/message-btn.png" alt="" /><span
              >确认</span
            >
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getGameList } from "@/api/game";
import { getToken } from "@/utils/auth";
export default {
  data() {
    return {
      loading: false,
      selectedIndex: 0,
      gameList: [],
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 8,
        timeSort: true,
      },
      // arrowX: 0,
      // arrowY: 0,
      gyroBtn: false,
      x: 0,
      y: 0,
      lastMoveTime: 0,
      moveCooldown: 200, // ms
      directionLock: null,
      moved: false,
      key: [],
      isGame: false,
      test: "",
      language: "zh",
      token: "",
      isFirstLoad: true,
      lastLoadTime: 0,
      noDataTimer: null,
      noDataTimeout: 10000, // 10秒无数据提醒
      isNoDataAlertShown: false,
      timerVersion: 0, // ✅ 新增唯一版本标记
      isReadyForKey: true,
      bKeyLock: false,
      dialogVisible: false,
    };
  },
  created() {
    // console.log(1111);
  },
  // mounted() {
  //   this.setupGyroDataReceiver();
  //   this.resetNoDataTimer();
  // },
  activated() {
    this.setupGyroDataReceiver();
    // 添加按键冷却期，避免刚进入时立刻响应
    this.isReadyForKey = false;
    setTimeout(() => {
      this.isReadyForKey = true;
    }, 300); // 可调节，比如 300ms 内忽略按键
    this.$nextTick(() => {
      const items = this.$refs.items;
      if (Array.isArray(items) && items[this.selectedIndex]) {
        items[this.selectedIndex].scrollIntoView({
          behavior: "auto",
          block: "nearest",
        });
      }
    });
  },
  deactivated() {
    window.__vueUnityHandler = null;

    if (this.noDataTimer) {
      clearTimeout(this.noDataTimer);
      this.noDataTimer = null;
    }
    this.timerVersion++;
  },
  computed: {
    noMore() {
      return this.gameList.length >= this.total;
    },
    disabled() {
      return this.loading || this.noMore;
    },
  },
  watch: {
    selectedIndex(newIndex) {
      this.$nextTick(() => {
        const items = this.$refs.items;
        if (Array.isArray(items) && items[newIndex]) {
          items[newIndex].scrollIntoView({
            behavior: "smooth",
            block: "nearest", // 或 center、start，按需调整
          });
        }
      });
    },
  },
  beforeDestroy() {
    if (this.noDataTimer) {
      clearTimeout(this.noDataTimer);
    }
    this.timerVersion++;
  },
  methods: {
    sendDataToUnity(value) {
      console.log(value, 222);
      location.href = `uniwebview://vue-message?type=${value}`;
    },
    load() {
      const now = Date.now();
      if (this.loading || this.noMore || now - this.lastLoadTime < 500) {
        return;
      }
      this.lastLoadTime = now;
      this.loading = true;
      if (getToken()) {
        this.init();
      }
    },
    async init() {
      try {
        // 异步操作
        const res = await getGameList(this.queryParams);
        const arr = res.result.records.map((el) => {
          const webGameName = el.webGameName.split("-");
          return {
            ...el,
            zh: webGameName[0],
            en: webGameName[1],
            inAddition: webGameName[2],
          };
        });
        this.gameList = [...this.gameList, ...arr];
        this.total = res.result.total;
        this.queryParams.pageNum++;
      } catch (error) {
        // this.loading = false;
        // 错误处理
        // console.error(error, 111);
        if (error === 401 || error === 1001) {
          this.sendDataToUnity("Login");
          return;
        }
        if (error === "无效的会话，或者会话已过期，请重新登录。") {
          // console.log(1111);
          this.sendDataToUnity("Login");
        } else {
          this.$message.error(error);
        }
      } finally {
        this.loading = false; // 无论成功失败，都要重置 loading 状态
      }
    },
    getElement() {
      this.$nextTick(() => {
        const element = document.querySelector(".selected");
        if (element) {
          const rect = element.getBoundingClientRect();
          // console.log("初始选中元素位置：", rect);
          this.arrowX = rect.x - 15;
          this.arrowY = rect.y + rect.height / 2 - 10;
        } else {
          // console.warn("❌ 页面初始找不到 .selected 元素");
        }
      });
    },
    goGame(item) {
      if (item.inAddition === "else") {
        this.$router.push({
          path: "/else",
          query: {
            id: item.id,
            src: item.webGameUrl,
            type: item.webGameType,
            screenOrientation: item.screenOrientation,
          },
        });
        return;
      }
      if (item.inAddition === "fullscreen") {
        this.$router.push({
          path: "/fullscreen",
          query: {
            id: item.id,
            src: item.webGameUrl,
            type: item.webGameType,
            screenOrientation: item.screenOrientation,
          },
        });
        return;
      }
      if (item.inAddition === "rom") {
        this.$router.push({
          path: "/rom",
          query: {
            id: item.id,
            src: item.webGameUrl,
            type: item.webGameType,
            screenOrientation: item.screenOrientation,
          },
        });
        return;
      }

      this.$router.push({
        path: "/game",
        query: {
          id: item.id,
          src: item.webGameUrl,
          type: item.webGameType,
          screenOrientation: item.screenOrientation,
        },
      });
    },
    setupGyroDataReceiver() {
      window.__vueUnityHandler = (data) => {
        // console.log(data, 111);
        // this.test = data;
        try {
          const parsedData = typeof data === "string" ? JSON.parse(data) : data;
          if (parsedData.type === "sensorData") {
            this.resetNoDataTimer(); // 每次收到数据时重置定时器
            this.filterAndUpdateSensorData(parsedData.gamepadData);
            this.language = parsedData.language;
            this.$store.dispatch("delLanguage", parsedData.language);
          }
        } catch (error) {
          console.error("❌ 解析 UniApp 数据失败:", error);
        }
      };
      this.resetNoDataTimer(); // 回到首页重启监听
    },
    resetNoDataTimer() {
      // console.log("✅ resetNoDataTimer 被调用");
      this.timerVersion++;
      const currentVersion = this.timerVersion;
      // 清除之前定时器
      if (this.noDataTimer) {
        clearTimeout(this.noDataTimer);
        // console.log("🧹 清除了旧定时器");
      }
      this.isNoDataAlertShown = false; // 收到数据，重置提醒状态

      // 设置新定时器
      this.noDataTimer = setTimeout(() => {
        // console.log("⏰ 触发 showNoDataAlert 定时器");
        if (this.timerVersion !== currentVersion) {
          console.log("🚫 定时器版本已过期，跳过 alert");
          return; // 如果版本不一致，说明被新定时器覆盖
        }
        this.showNoDataAlert();
      }, this.noDataTimeout);
    },
    showNoDataAlert() {
      if (this.isNoDataAlertShown) return;
      this.isNoDataAlertShown = true;
      this.dialogVisible = true;
    },
    enterEsc() {
      this.sendDataToUnity("Close");
      this.dialogVisible = false;
    },
    filterAndUpdateSensorData(value) {
      // console.log(value.token, getToken());
      if (getToken() !== value.token) {
        console.log("重置token");
        this.isFirstLoad = false;
        this.$store
          .dispatch("enterLogin", value.token)
          .then(() => {
            this.pageNum = 1;
            this.gameList = [];
            this.init();
          })
          .catch(() => {});
      } else if (this.isFirstLoad) {
        // token 一致，但是首次接收数据
        console.log("token 一致，但是首次接收数据");
        this.pageNum = 1;
        this.gameList = [];
        this.init();
        this.isFirstLoad = false; // 设置为 false，避免重复初始化
      }

      this.$store.dispatch("delData", value);
      this.gyroBtn = value.gyroBtn;
      this.key = value.key;
      // // console.log(value.key);
      this.x = value.direction.x;
      this.y = value.direction.y;
      this.token = value.token;
      this.onKeyDown();
      this.selectGame();
    },
    onKeyDown() {
      const now = Date.now();
      const total = this.gameList.length;
      const cols = 4;
      const rows = Math.ceil(total / cols);
      if (now - this.lastMoveTime < this.moveCooldown) {
        return; // 太快，忽略
      }
      let index = this.selectedIndex;
      // let col = index % cols;
      let row = Math.floor(index / cols);
      if (this.x > 0.5 && this.directionLock !== "right") {
        this.selectedIndex = (this.selectedIndex + 1) % total;
        this.directionLock = "right";
        this.moved = true;
      } else if (this.x < -0.5 && this.directionLock !== "left") {
        this.selectedIndex = (this.selectedIndex - 1 + total) % total;
        this.directionLock = "left";
        this.moved = true;
      } else if (this.y < -0.5 && this.directionLock !== "down") {
        if (row < rows - 1) {
          const col = index % cols;
          let nextIndex = (row + 1) * cols + col;
          if (nextIndex >= total) {
            // 当前列没有，跳下一行第一个
            nextIndex = (row + 1) * cols;
          }
          if (nextIndex < total) {
            this.selectedIndex = nextIndex;
            this.directionLock = "down";
            this.moved = true;
          }
        }
      } else if (this.y > 0.5 && this.directionLock !== "up") {
        if (row > 0) {
          this.selectedIndex = index - cols;
          this.directionLock = "up";
          this.moved = true;
        }
      }

      if (this.moved) {
        this.lastMoveTime = now;
        setTimeout(() => {
          if (Math.abs(this.x) < 0.2 && Math.abs(this.y) < 0.2) {
            this.directionLock = null;
            // console.log(this.directionLock);
            this.moved = false;
          }
        }, 100);
      }
      // this.getElement();
    },
    selectGame() {
      if (!this.isReadyForKey) return; // 防止页面刚激活时误触
      if (this.isGame) return;

      if (this.key.indexOf("A") !== -1 && this.$route.path !== "/game") {
        const item = this.gameList[this.selectedIndex];
        if (item.inAddition === "else") {
          // console.log(11111);
          this.$router.push({
            path: "/else",
            query: {
              id: item.id,
              src: item.webGameUrl,
              type: item.webGameType,
              screenOrientation: item.screenOrientation,
            },
          });
          this.isGame = true;
          return;
        }
        if (item.inAddition === "rom") {
          // console.log(11111);
          this.$router.push({
            path: "/rom",
            query: {
              id: item.id,
              src: item.webGameUrl,
              type: item.webGameType,
              screenOrientation: item.screenOrientation,
            },
          });
          this.isGame = true;
          return;
        }
        this.$router.push({
          path: "/game",
          query: {
            id: item.id,
            src: item.webGameUrl,
            type: item.webGameType,
            screenOrientation: item.screenOrientation,
          },
        });
        this.isGame = true;
      }

      if (this.key.indexOf("B") !== -1 && this.$route.name === "home") {
        if (this.bKeyLock) return; // 锁定期间不响应
        this.bKeyLock = true;
        this.sendDataToUnity("Close");
        setTimeout(() => {
          this.bKeyLock = false;
        }, 500);
        // this.isGame = true;
      }
      setTimeout(() => {
        this.isGame = false;
      }, 1000);
    },
  },
};
</script>
<style lang="scss" scoped>
.home {
  width: 100vw;
  height: 100vh;
  background: url("../../assets/img/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .back {
    position: absolute;
    top: 0;
    left: 0;
    width: 312px;
    height: 140px;
    background: url("../../assets/img/backbg.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    box-sizing: border-box;
    padding: 22px 0 0 80px;
    z-index: 100000;
    > div {
      display: flex;
      align-items: center;
      height: fit-content;
      img {
        width: 40px;
        height: 40px;
        // margin-top: 6px;
      }
      p {
        font-weight: bold;
        font-size: 32px;
        color: #a052ae;
        //line-height: 46px;
        margin-left: 8px;
      }
    }
  }
  .explain {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    align-items: center;
    padding: 17px 60px 0 0;
    p {
      font-weight: bold;
      font-size: 32px;
      color: #ffffff;
      line-height: 46px;
      margin-left: 24px;
    }
  }
  .box {
    height: 100%;
    // overflow: hidden;
    padding-top: 96px;
    position: relative;
    box-sizing: border-box;
    z-index: 100;
    padding-right: 8px;
    .infinite-list-wrapper {
      padding: 0 86px;
      box-sizing: border-box;
      height: 100%;
      ul {
        display: flex;
        flex-wrap: wrap;
        margin-top: 44px;
        li {
          margin-bottom: 42px;
          width: calc(25% - 36px);
          margin-right: 42px;
          background: url("../../assets/img/box.png") no-repeat;
          background-size: 100% 100%;
          position: relative;
          .item-img {
            width: 100%;
            height: 200px;
            display: flex;
            align-items: center;
            justify-content: center;
            > div {
              width: 90%;
              height: 90%;
              // background: url("../../assets/img/imgbg.png") no-repeat;
              margin-top: 4px;
              background-size: 100% 100%;
              overflow: hidden;
              border-radius: 30px 10px 10px 10px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                // max-width: 95%;
                width: 108%;
                // margin-top: -10px;
                // height: 100%;
                // object-fit: contain;
                //
              }
            }
          }
          p {
            padding: 8px 0 21px;
            text-align: center;
            font-weight: bold;
            font-size: 24px;
            color: #396e8c;
            line-height: 35px;
          }
          .arrow {
            animation: moveArrow 0.5s ease-in-out infinite;
            position: absolute;
            top: 50%;
            margin-top: -20px;
            left: 0;
            margin-left: -10px;
            z-index: 1000;
            img {
              width: 28px;
              height: 40px;
            }
          }

          @keyframes moveArrow {
            0% {
              transform: translateX(0);
            }

            50% {
              transform: translateX(2px);
            }

            100% {
              transform: translateX(0);
            }
          }
        }
        li:nth-child(4n) {
          margin-right: 0;
        }
        .selected {
          // box-shadow: 2px 3px 4px 1px rgba(0, 0, 0, 0.28),
          //   0px 0px 7px 7px #cf4fca,
          //   inset 0px -3px 8px 0px rgba(108, 193, 231, 0.74);
          background: url("../../assets/img/box_active.png") no-repeat;
          background-size: 100% 100%;
          transform: scale(1.1); /* 微放大 */
          z-index: 2;
        }
      }
    }
  }
}
.test {
  padding: 20px 350px;
  background: #fff;
}
</style>
